module.exports = {
    props: ['user', 'team', 'billableType'],

    /**
     * Load mixins for the component.
     */
    mixins: [
        require('./../mixins/plans'),
        require('./../mixins/subscriptions')
    ],


    /**
     * The component's data.
     */
    data() {
        return {
            plans: []
        };
    },


    /**
     * Prepare the component.
     */
    mounted() {
        var self = this;

        this.getPlans();

        this.$on('showPlanDetails', function (plan) {
            self.showPlanDetails(plan);
        });
    },


    methods: {
        /**
         * Get the active plans for the application.
         */
        getPlans() {
            let teamId = this.team  && this.team.id ? this.team.id : null;
            let url = '/spark/plans';

            if (teamId) {
                url = url + '?team-id=' + teamId
            }

            axios.get(url)
                .then(response => {
                    this.plans = this.billingUser
                                    ? _.filter(response.data, {type: "user"})
                                    : _.filter(response.data, {type: "team"});
                });
        }
    }
};
